import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, SecurityContext, inject, type OnInit } from '@angular/core';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { IconBigMediumPfeilRechts, IconBigMediumSchliessen, IconComponent } from '@big-direkt/utils/icons';
import { SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgPopoverRef } from 'ng-overlay-container';
import { BigtionaerOverlayData } from '../../models/bigtionaer-overlay-data.model';
import { ModalFrameComponent } from '../modal-frame/modal-frame.component';

@Component({
    selector: 'big-ui-modal-bigtionaer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './bigtionaer.component.html',
    imports: [A11yModule, TranslocoDirective, SanitizePipe, IconComponent, UiButtonComponent, ModalFrameComponent],
})
export class ModalBigtionaerComponent implements OnInit {
    public readonly popoverRef = inject<NgPopoverRef<BigtionaerOverlayData>>(NgPopoverRef);
    public readonly iconClose = IconBigMediumSchliessen;
    public readonly iconArrowRight = IconBigMediumPfeilRechts;
    public readonly securityContext = SecurityContext.HTML;

    public title?: string;
    public description?: string;
    public text1?: string;
    public showMore1Callback?: (popoverRef: NgPopoverRef<BigtionaerOverlayData>) => void = undefined;
    public text2?: string;
    public showMore2Callback?: (popoverRef: NgPopoverRef<BigtionaerOverlayData>) => void = undefined;

    public ngOnInit(): void {
        const { title, description, text1, text2, showMore1Callback, showMore2Callback } = this.popoverRef.data;

        this.title = title;
        this.description = description;
        this.text1 = text1;
        this.showMore1Callback = showMore1Callback;
        this.text2 = text2;
        this.showMore2Callback = showMore2Callback;
    }
}
